<div
  class="p-15px"
  *ngIf="
    !failedLoadingRichList ||
    !failedLoadingTotalSupply ||
    !failedLoadingCountKeysWithDESO
  "
>
  <simple-center-loader
    *ngIf="loadingTotalSupply && loadingRichList"
  ></simple-center-loader>
  <div>
    Total Supply: {{ loadingTotalSupply ? '...loading' : totalSupplyDESO }}
  </div>
  <div>
    Count of Public Keys Holding DESO:
    {{ loadingCountKeysWithDESO ? '...loading' : countKeysWithDESO }}
  </div>
  <div *ngIf="!loadingRichList">
    <div class="d-flex fs-12px align-items-center justify-content-start">
      <div class="col-1">Rank</div>
      <div class="col-4">Public Key</div>
      <div class="col-2">Balance (DESO)</div>
      <div class="col-2">Percentage</div>
      <div class="col-2">USD Value</div>
    </div>
    <div
      #uiScroll
      *uiScroll="let entry of datasource; let ii = index"
      class="d-flex fs-12px align-items-center justify-content-start"
    >
      <div class="col-1">#{{ ii + 1 }}</div>
      <div class="col-4 d-flex align-items-start">
        <div class="text-truncate">{{ entry.PublicKeyBase58Check }}</div>
      </div>
      <div class="col-2">{{ globalVars.nanosToDeSo(entry.BalanceNanos) }}</div>
      <div class="col-2">{{ (entry.Percentage * 100).toFixed(2) }} %</div>
      <div class="col-2">
        {{ globalVars.nanosToUSD(entry.BalanceNanos, 2) }}
      </div>
    </div>
  </div>
</div>
<div
  class="p-15px"
  *ngIf="
    failedLoadingRichList &&
    failedLoadingTotalSupply &&
    failedLoadingCountKeysWithDESO
  "
>
  <div>This node does not support monitoring of supply statistics.</div>
</div>
